import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/vatPlan', request)
}

async function post(request) {
    return await postMethod('/api/vatPlan', request)
}

async function put(vatPlanId, request) {
    return await putMethod(`/api/vatPlan/${vatPlanId}`, request)
}

export {post, get, put}
